import Highcharts from 'highcharts';

/**
 * Gets y values of data points of series
 *
 * Only implemented for chart types: scatter, line, xrange
 */
export function getSeriesYValues(series: Highcharts.SeriesOptionsType) {
    switch (series.type) {
        case 'scatter':
        case 'line':
            return (
                (series.data ?? [])
                    // Extract y value (or null) out of each data point, which has a complicated union type...
                    .map((p) => {
                        if (p === null) {
                            return null;
                        }
                        // (x, y) tuple
                        if (Array.isArray(p)) {
                            return p[1];
                        }
                        // Object with y property
                        if (typeof p === 'object') {
                            return p.y;
                        }
                        // Just a number
                        return p;
                    })
                    .filter((x) => x != null)
            );
        case 'xrange':
            return (
                (series.data ?? [])
                    // Get non-null y values
                    .map((d) => d.y)
                    .filter((x) => x != null)
            );
        default:
            return [];
    }
}
